import { IResponse } from '@estee/elc-http-transport';

import { ICollection, IOrderObject, IPGResponse } from '~api/CartAPI/ICartApiSdk';

export const reduceReplenishmentInfo = (res: IResponse<IPGResponse<IOrderObject>[]>) => {
    const { result, error } = res?.data?.[0] as IPGResponse<IOrderObject>;
    const errMsg = error?.data?.messages?.[0]?.text;
    const newFreq = result?.data?.coll_info?.REPLENISHMENT_FREQ;
    const collectionId = result.data?.collection_id;

    return { errMsg, newFreq, collectionId };
};

export const reduceReplenishmentFrequency = (res: IPGResponse<ICollection>) =>
    res?.result?.value?.collection?.REPLENISHMENT_FREQ?.toString() || '';
